import { apiFetch } from "./config.js";
/** Every message so far in this claim's bounded chat, oldest first. */
export async function listClaimChatMessages(claimId, signal) {
    return apiFetch(`/claim-candidates/${encodeURIComponent(claimId)}/chat`, { signal });
}
/** Sends a question about this claim and gets back both the stored user message and the answer. */
export async function sendClaimChatMessage(claimId, message) {
    return apiFetch(`/claim-candidates/${encodeURIComponent(claimId)}/chat`, {
        method: "POST",
        body: { message },
    });
}
